import { TrendingFeed } from '../components/TrendingFeed';

export function TrendingPage() {
  return (
    <div className="container mx-auto py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            Top 100 Trending
          </h1>
          <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 dark:text-gray-400 sm:mt-4">
            The biggest movers and shakers across all Billboard charts this week
          </p>
        </div>
      </div>
      <TrendingFeed preview={false} />
    </div>
  );
} 